/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
const isLocalhost = Boolean(window.location.hostname === "localhost" || window.location.hostname === "[::1]" || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
export function register(config) {
  if ("serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
        return;
    }
    window.addEventListener("load", () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
        if (isLocalhost) {
            checkValidServiceWorker(swUrl, config);
            navigator.serviceWorker.ready.then(() => {
                console.log("This web app is being served cache-first by a service " + "worker. To learn more, visit https://bit.ly/CRA-PWA");
            });
        } else {
            registerValidSW(swUrl, config);
        }
    });
  }
}
function registerValidSW(e, config) {
    navigator.serviceWorker
        .register(e)
        .then((reg) => {

            if (reg.waiting) {
              config.onUpdate(reg);
              return;
            }

            if (reg.installing) {
              trackInstalling(reg.installing, config);
              return;
            }

            reg.onupdatefound = () => {
                const installingWorker = reg.installing;

                if (installingWorker) {
                  installingWorker.onstatechange = () => {
                      if (installingWorker.state === "installed") {
                          // emit onUpdate once a new version is successfully installed
                          if (navigator.serviceWorker.controller) {
                              console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                              if (config && config.onUpdate) {
                                  config.onUpdate(reg);
                              }
                          } else {
                              console.log("Content is cached for offline use.");
                              if (config && config.onSuccess) {
                                  config.onSuccess(reg);
                              }
                          }
                      }
                  };
                }

              const waitingWorker = reg.waiting;
              if (waitingWorker == null) {
                return;
              }
 
              config.onUpdate(reg);
            };
          })
          .catch((e) => {
              console.error("Error during service worker registration:", e);
          });

      try {

        // Prefetch images that may displayed while evaluation is in-use
        navigator.serviceWorker.addEventListener('install', event => {
          event.waitUntil(
            caches.open('image-cache').then(cache => {
              // List of image URLs to prefetch
              const urlsToPrefetch = [
                '/eval/images/prefetch/*'
              ];

              // Fetch and cache each image
              return Promise.all(
                urlsToPrefetch.map(url =>
                  fetch(url).then(response =>
                    cache.put(url, response)
                  )
                )
              );
            })
          );
        });

        // Add an event listener for when fetch requests are made
        navigator.serviceWorker.addEventListener('fetch', event => {
          event.respondWith(
            caches.match(event.request).then(response => {
              return response || fetch(event.request);
            })
          );
        });
      } catch (e) {
        console.error('error prefetching images:', e);
      }

    let refreshing;

    navigator.serviceWorker.addEventListener('controllerchange', function() {
      if (refreshing) {
        return;
      }
      window.location.reload();
      refreshing = true;
    });
}

function trackInstalling(reg, config) {
  const installingWorker = reg.installing;
  installingWorker.addEventListener('statechange', function() {
    if (installingWorker.state == 'installed') {
      config.onUpdate(reg);
    }
  });
};

function checkValidServiceWorker(e, o) {
    fetch(e)
        .then((n) => {
            const r = n.headers.get("content-type");
            if (n.status === 404 || (r != null && r.indexOf("javascript") === -1)) {
                navigator.serviceWorker.ready.then((e) => {
                    e.unregister().then(() => {
                        window.location.reload();
                    });
                });
            } else {
                registerValidSW(e, o);
            }
        })
        .catch(() => {
            console.log("No internet connection found. App is running in offline mode.");
        });
}
export function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then((e) => {
            e.unregister();
        });
    }
}
